<template>
  <div class="page" v-wechat-title="$route.meta.title='我的'">

    <!--头像部分-->
    <div class="header">
      <img class="user-bg" src="https://filewc.geeker.com.cn/%E9%87%91%E7%89%8C%E8%A7%A3%E8%AF%B4%E5%B0%8F%E7%A8%8B%E5%BA%8F/user_bg.png"/>
      <div class="header-info" style="display: none;">
        <img src="../../assets/user_info.png" />
        <p class="has-mes" v-if="noticeNUmber > 0">{{noticeNUmber}}</p>
      </div>

      <div class="header-img box">
        <p class="userinfo-avatar"><img class="img" :src="userInfo.headimgurl" alt=""></p>

        <div class="flex ">
          <p class='header-name'>{{userInfo.name}}</p>

          <template  v-if="vipInfo.isvip">
            <p class='header-vip'>平台畅享会员 <br/>到期时间：{{vipInfo.gdate}} </p>
            <img class="rz-icon" src="../../assets/pay-member.png" alt="">
          </template>
          <template  v-if="root.isrz&&root.type==1&&!vipInfo.isvip">
            <p class='header-vip'>认证导游</p>
            <img class="rz-icon" src="../../assets/icon-rz-dy1.png" alt="">
          </template>
        </div>

      </div>
    </div>

    <!--标签部分-->
    <div class="lable" style="display: none">
      <router-link :to="{path: '/myaccount', query: {TimeStamp: TimeStamp}}">
        <img class="lable-img" src="../../assets/user_money.png" alt="">
        <p class="lable-text">我的账户</p>
      </router-link>
      <router-link :to="{path: '/commentary', query: {TimeStamp: TimeStamp}}">
        <img class="lable-img" src="../../assets/js1.png" alt="">
        <p class="lable-text">我的解说</p>
      </router-link>
      <router-link :to="{path: '/purchase', query: {TimeStamp: TimeStamp}}">
        <img class="lable-img" src="../../assets/shopcar.png" alt="">
        <p class="lable-text">我的已购</p>
        <i class="new-mes"></i>
      </router-link>
    </div>

    <!--快捷菜单-->
    <div class="nav">
      <router-link class="nav-item" :to="{path: '/purchase', query: {TimeStamp: TimeStamp,appKey: appKeyA}}" >
        <img class="nav-info-img" src="../../assets/certification.png" alt="">
        <p class="nav-left-text">
          <!--金牌认证-->
          我的已购
          <img class="nav-back-img" src="../../assets/back.png" alt="">
        </p>
      </router-link>
      <router-link class="nav-item" :to="{path: '/coupon-list', query: {TimeStamp: TimeStamp,appKey: appKeyA}}">
        <img class="nav-info-img" src="../../assets/coupon.png" alt="">
        <p class="nav-left-text">
          我的优惠券
          <span class="nav-left-tip" v-if="award>0">{{award}}</span>
          <img class="nav-back-img" src="../../assets/back.png" alt="">
        </p>
      </router-link>
      <router-link class="nav-item" :to="{path: '/listen-history', query: {TimeStamp: TimeStamp,appKey: appKeyA}}">
        <img class="nav-info-img" src="../../assets/history.png" alt="">
        <p class="nav-left-text">
          收听历史
          <img class="nav-back-img" src="../../assets/back.png" alt="">
        </p>
      </router-link>
      <router-link class="nav-item" :to="{path: '/my-comment', query: {TimeStamp: TimeStamp,appKey: appKeyA}}">
        <img class="nav-info-img" src="../../assets/comment.png" alt="">
        <p class="nav-left-text">
          我的评论
          <img class="nav-back-img" src="../../assets/back.png" alt="">
        </p>
      </router-link>
      <div class="nav-item" @click="goExtend">
        <img class="nav-info-img" src="../../assets/extend_icon04.png" alt="">
        <p class="nav-left-text">
          推广赚钱
          <img class="nav-back-img" src="../../assets/back.png" alt="">
        </p>
      </div>
      <div class="nav-item" @click="feedbackFun">
        <img class="nav-info-img" src="../../assets/suggest.png" alt="">
        <p class="nav-left-text">
          意见反馈
          <img class="nav-back-img" src="../../assets/back.png" alt="">
        </p>
      </div>
      <router-link class="nav-item" :to="{path: '/agreement', query: {id: '2', TimeStamp: TimeStamp}}">
        <img class="nav-info-img" src="../../assets/icon-copy.png" alt="">
        <p class="nav-left-text">
          版权申明
          <img class="nav-back-img" src="../../assets/back.png" alt="">
        </p>
      </router-link>

    </div>

    <!--底部导航栏-->
    <Foot :siteid="siteid" :sregion="sregion" :appKeyA="appKeyA" ></Foot>

    <!--意见反馈弹窗-->
    <AlertFeedback :class="{'none':feedbackShow==0,'curr':feedbackShow==1}" v-on:child-Feedback="closeFeedback"></AlertFeedback>

  </div>

</template>

<script>

import { mapState, mapMutations } from 'vuex'
import {wxGetPosition,wxShareme} from '@/utils/wechat'
import Foot from '../../components/Foot'
import AlertFeedback from '../../components/AlertFeedback'
import {getNoticeNumber, getUserRZ, getIsRegister,userIsVip} from "@/service/getData";
import {setStore, getStore, removeStore} from '@/config/mUtils'

import wxConfirm from '@/wechat-messagebox/Confirm'
import D from '@/wc-messagebox'
import Vue from 'vue'
Vue.use(D)

export default {
    data(){
        return{
          root:{
            isrz:0,
            type:0,  //0：普通身份证认证，1：平台导游认证
            count:0
          },
          citycode: this.$route.query.citycode || 1,
          cityInfo: { citycode: 1, city: "全部", address: "" },
          noticeNUmber: 0, //消息数量
          award: 0, //优惠券数量
          userInfo: {},
          sregion: '', //省站点id:430000
          siteid: '', //站点id
          isRegister:0,//是否注册
          TimeStamp: new Date().getTime(),  //获取当前时间
          appKey: '',
          appKeyA: '',
          feedbackShow:0,//意见反馈弹窗
          vipInfo: {
            gdate: "", //会员过期时间
            isvip: false //是否是会员
          }
        }
    },
    computed: {

    },
    created() {
      this.cityInfo.citycode = this.citycode
      this.siteid = this.$route.query.siteid || getStore("siteid") || "";
      if (this.siteid != "" && this.siteid != null && this.siteid != undefined) {
        setStore("siteid", this.siteid);
        removeStore("sregion")
      }
      this.cityInfo = getStore("cityInfo");

      this.sregion = this.$route.query.sregion || getStore("sregion") || "";
      if (this.sregion != "" && this.sregion != null && this.sregion != undefined) {
        setStore("sregion", this.sregion);
        this.siteid = '';
        removeStore("siteid")
      }

      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      this.id = this.$route.query.id;
      if (this.appKey) {
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey": this.appKey});
      } else {
        setStore("appKey", {"appKey": ""});
      }

      this.initData();
    },
    methods: {

      //获取信息
      async initData(){
        this.userInfo = getStore("userInfo");

        //获取消息提醒和优惠券数量
        let res1 = await getNoticeNumber({
          openid: this.userInfo.openid
        });
        if (res1.errcode == '00000') {
          this.noticeNUmber = res1.data.total;
          if(res1.data.award){
            this.award = res1.data.award
          }
        }else {
          this.$toast(res1.errmsg)
        }

        //是否认证过平台导游
        let res2 = await getUserRZ({
          openid: this.userInfo.openid
        });
        if (res2.errcode == '00000') {
          this.root = res2.data
        }

        //是否注册过推广赚钱功能
        let res3 = await getIsRegister({
          openid: this.userInfo.openid
        });
        if (res3.errcode == '00000') {
          if(res3.data == true){
            this.isRegister = 1
          }else{
            this.isRegister = 0
          }
        }

        let res4 = await userIsVip({
          openid: this.userInfo.openid
        });
        if (res4.errcode == '00000') {
          this.vipInfo = res4.data
        }

        let title = this.userInfo.name + '@你：';
        let desc = '我正在“金牌解说”，一起来听景区故事吧';
        let link = '/user?siteid=' + this.siteid + '&sregion=' + this.sregion + '&appKey=' + this.appKey;
        wxShareme(title,desc,"",link);

      },

      //推广登录
      async goExtend(){
        let user = getStore("user",1) || "";
        if(user && user.user != '' && user.user != null && user.user != undefined){
          this.$router.push({
            path: `/extend-center?${'id='+user.user}`
          });
        }else {
          if(this.isRegister==0){
            this.$router.push({
              path: `/extend-index`
            });
          }else{
            this.$router.push({
              path: `/extend-login`
            });
          }
        }
      },


      //显示与隐藏意见反馈
      feedbackFun(){
        MtaH5.clickStat("video_play_menu_feedback");//点击反馈数据统计
        if(this.feedbackShow==0){
          this.feedbackShow=1
        }else{
          this.feedbackShow=0
        }
      },

      //意见反馈弹窗隐藏
      closeFeedback :function(feedbackClose){
        this.feedbackShow = feedbackClose
      },

    },
    components: {
      Foot,
      AlertFeedback
    },

}

</script>

<style scoped>

  .page{ background:  #f9f9f9; min-height: 100vh; padding-bottom: 0; }
  .header{ position: relative; width: 100%; height: 2.4rem; overflow: hidden; }
  .user-bg{ position:absolute; top:0; right:0; width: 65%; height: 100%; }
  .header-info{ flex-direction:row; position:relative; float: right; margin-top: .65rem; margin-right: .41rem; }
  .rz-icon{ position: absolute; top:.9rem; left:.9rem; width: .38rem; height: .39rem; }
  .has-mes{ position:absolute; top:-.20rem; right:-.10rem; padding:.03rem .10rem; font-size:.20rem; color:#fff; background:#d25603; border-radius:.10rem; }
  .header-info img{ width: .44rem; height: .44rem; }
  .header-img{ position: absolute; top:.57rem; left: .33rem; width: 88%; height:1.30rem;-webkit-box-align: center; -ms-flex-align: center; align-items: center; }
  .userinfo-avatar{ margin-right: .3rem; width:1.3rem; height:1.3rem; border-radius: 50%; background-color: #faf3e5; border:1px solid #faf3e5; overflow: hidden; }
  .header-name{font-size: .30rem; color: #595959; font-weight: bold; }
  .header-vip{ margin-top: .1rem; font-size: .24rem; color: #faaf39;}
  .lable{ display: flex; width: 100%; height: 1.40rem; padding: .18rem 0 .16rem 0; background-color: #ffffff; box-sizing: border-box; border-bottom: 1px solid #eaeaea; }
  .lable>a{ position: relative; width:33.33%; height:.93rem; border-right:1px solid #e2e2e2; }
  .lable>a:last-child{ border-right: none; }
  .lable-img{ display:block; margin:0 auto; width:.54rem; height:.54rem; }
  .lable-text{ display: block; width: 100%; height: .28rem; line-height: .28rem; margin-top: .12rem; font-family: STXihei; font-size: .24rem; font-weight: normal; font-style: normal; font-stretch: normal; letter-spacing: -.006rem; text-align: center; color: #818181; }
  .new-mes{ position: absolute; top:0; left:60%; width: .17rem; height: .17rem; border-radius: 50%; background: #f15454; }
  .nav{ margin-top: .22rem; background:#fff; box-sizing:border-box; padding:0 .30rem; }
  .nav-item{ position:relative; display: flex; width: 100%; height: .92rem; line-height: .92rem; justify-content: space-between; padding: .30rem .30rem .30rem .94rem; box-sizing: border-box; border-bottom:1px solid #e3e3e3; }
  .nav-item:last-child{ border-bottom:none; }
  .nav-left-text{ position:absolute; left:.84rem; right:0; top:0; height: .92rem; line-height: .92rem; font-family: STXihei; font-size: .28rem; font-weight: normal; font-style: normal; font-stretch: normal; letter-spacing: -.006rem; text-align: left; color: #666; }
  .nav-item:last-child .nav-left-text{ border-bottom: none; }
  .nav-info-img{ position:absolute; top:.28rem; left:.20rem; width: .36rem; height: .36rem; }
  .nav-back-img{ float:right; width:.15rem; height:.30rem; margin-top:.32rem; margin-right:.10rem; }
  .nav-left-tip{ display: inline-block; margin-left: .2rem; width: .3rem; height: .3rem;line-height: .3rem; text-align: center; font-size:.2rem; color:#fff; background-color: #f15454; border-radius: 50%; }



</style>



// WEBPACK FOOTER //
// src/page/user/user.vue